// Add your custom JS here.


(function($) {
      

  /*
   *
   * Disable creative animation for specific screen sizes
   * 
   */
  
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  //if (viewportWidth >= 992 && viewportHeight < 990) {
  if (viewportWidth < 1200 ) {
    $('.ecp-block-creative .creative-container > article:nth-child(1), .ecp-block-creative .creative-container > article:nth-child(2), .ecp-block-creative .creative-container > article:nth-child(3), .ecp-block-creative .creative-container > article:nth-child(4), .ecp-block-creative .creative-container > article:nth-child(5), .ecp-block-creative .creative-container > article:nth-child(6), .ecp-block-creative .creative-container > .article-container:nth-child(1), .ecp-block-creative .creative-container > .article-container:nth-child(2), .ecp-block-creative .creative-container > .article-container:nth-child(3), .ecp-block-creative .creative-container > .article-container:nth-child(4), .ecp-block-creative .creative-container > .article-container:nth-child(5), .ecp-block-creative .creative-container > .article-container:nth-child(6)').each(function(){
      //$(this).find('.animated').removeClass('animated');
      $(this).find('.slideInLeft').removeClass('slideInLeft');
      $(this).find('.slideInUp').removeClass('slideInUp');
      $(this).find('.slideInRight').removeClass('slideInRight');
      $(this).find('.delay-500ms').removeClass('delay-500ms');
      
      $(this).find('.fadeIn').removeClass('fadeIn');
      $(this).find('.animated .animated').removeClass('animated');
      $(this).find('.animated').addClass('fadeIn');
    });

  }


/*
   *
   * Autoplay animations
   * 
   */
  const imageContainers = gsap.utils.toArray('.ecp-block-section-object-image-container.autoplay, .ecp-block-section-type-color-image-container.autoplay');
  imageContainers.forEach((container) => {
  gsap.from(container, {
    scrollTrigger: {
      start: 'center bottom',
      end: 'bottom top',
      trigger: container,
      toggleClass: 'toggled'
    }
  }, 1);
});

  
  /*
   *
   * ECP Sign Hover State
   * 
   */
  var lightDuration = 2000; 

  $('.ecp-sign-light-hover').mouseenter(function(){
   
      enableLight(this);
    
  }).mouseleave(function(){
    
    disableLight(this);
  }).on('touchmove', function() {
    enableLight(this, true);
  });

function enableLight(element, autoOff) {
  if (!element) return false;

  var lightIndex = getElementIndex(element) + 1;
  $('.ecp-sign-light-container picture:nth-child(' + lightIndex + ') .ecp-sign-light').addClass('toggled');

  
  if (autoOff) {
    setTimeout(function(){ disableLight(element); }, 3000); // This extends the delay
  }
}
function disableLight(element) {
  if (!element) return false;
  
  var lightIndex = getElementIndex(element) + 1;

  setTimeout(function(){
    $('.ecp-sign-light-container .ecp-sign-light:nth-child(' + lightIndex + ')').removeClass('toggled');

  }, lightDuration);
}


  function getElementIndex(element) {
    // get index - based on https://stackoverflow.com/questions/5913927/get-child-node-index
    
    if (!element) return false;

    var parent = element.parentNode;
    var index = Array.prototype.indexOf.call(parent.children, element);
    //console.log('ok ' + index);
    return index;
  }

  



 

  /*
   * Blog listing hover state 
   * Reveals the post thumbnail and makes that image follow the user's mouse. 
   * No thumbnails on mobile...
   */
  
  var followMouse = false;
  const titleLinkQuery = '.wp-block-latest-posts__post-title';
  // const titleLinkQuery = '.blog article .entry-title a, .archive article .entry-title a, .search article .entry-title a, .wp-block-latest-posts__post-title';
  $(titleLinkQuery).mousemove(function(e){
    if (followMouse) {
      var x = e.clientX;
      var y = e.clientY;
      const thumb = getEntryThumbImgEl(this);
      console.log('Mouse: ' + x + ',' + y);
      if (thumb) {
        $(thumb).css({top: y, left: x});
        console.log(thumb);
      }
    } 
  });
  $(titleLinkQuery).mouseenter(function(e){
    followMouse = true;
    const thumb = getEntryThumbImgEl(this);
    if (thumb) {
      $(thumb).show();
    }
    
  });
  $(titleLinkQuery).mouseleave(function(e){
    followMouse = false;
    const thumb = getEntryThumbImgEl(this);
    if (thumb) {
      $(thumb).hide();
    }
  });

  function getEntryThumbImgEl(el) {
    if (!el) return false;
    var parent = $(el).parent().closest('article, li');
    var thumb = $(parent).children('img, .wp-block-latest-posts__featured-image').first();
    console.log(parent.length);
    console.log(thumb.length);

    if (parent.length == 0 || thumb.length == 0) return false;  

    return thumb;
  }

  /*
   * Slick Slider
   */

  $('.featured-container').slick({
    lazyLoad: 'ondemand',
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    prevArrow: '<div class="slick-prev slick-arrow"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
    nextArrow: '<div class="slick-next slick-arrow"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
  });


  /*
  * Services list column
  */

  $('.services-list-column').each(function(){
    var first_ul = $(this).find('ul')[ 0 ]; // Find the list
    $(first_ul).clone().addClass("clone").appendTo( this ).clone().appendTo( this ); // duplicate it twice

  });



    /*
     * Object section links 
     */


    $('.ecp-block-section-object .wp-block-button__link').mouseenter(function(){
      var imgContainer = $(this).parent().parent().children('.ecp-block-section-object-image-container');
      if (imgContainer) {
        imgContainer = imgContainer[0];
        $(imgContainer).addClass('toggled');
      } 
      $(this).addClass('toggled');


    }).mouseleave(function(){
      var imgContainer = $(this).parent().parent().children('.ecp-block-section-object-image-container');
      if (imgContainer) {
        imgContainer = imgContainer[0];
        $(imgContainer).removeClass('toggled');
      }
      $(this).removeClass('toggled');
    });

    $('a.ecp-block-section-object-image-container, .ecp-block-section-type-color-image-container').mouseenter(function(){
      var sectionLink = $(this).parent().find('.wp-block-button__link');
      if (sectionLink) {
        sectionLink = sectionLink[0];
        $(sectionLink).addClass('toggled');
      }
      $(this).addClass('toggled');

    }).mouseleave(function(){
      var sectionLink = $(this).parent().find('.wp-block-button__link');
      if (sectionLink) {
        sectionLink = sectionLink[0];
        $(sectionLink).removeClass('toggled');
      }
      $(this).removeClass('toggled');
    });


    /*
   $('.ecp-block-section-object .wp-block-button__link, .ecp-back-button > a, .ecp-block-section-object .wp-block-image > a, a.ecp-block-section-object-image-container ').click(function(e){
   


    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth >= 768) {
      console.log('Wide viewport');
      var thisContainer = $(this).closest('.ecp-block-section-object-container2');
      if (thisContainer) {
        e.preventDefault();
        var offset = $(thisContainer).offset();
        //window.scrollTo(0, offset.top); // this works to scroll down to the content but doesn't scroll back up...
        thisContainer.toggleClass('toggled');
  
      }
    } else {
      console.log('Small viewport');
      
    }



   });
   
*/



   /*
 * Close all side sections
 */
function closeObjectSections() {
 
  $('.ecp-block-section-object .wp-block-button__link').each(function(){
    var thisContainer = $(this).closest('.ecp-block-section-object-container2');
    if (thisContainer) {
      thisContainer.removeClass('toggled');
    }
  });

}
 

/*
 * Do brush animation
 * https://ide.geeksforgeeks.org/online-html-editor/6b061782-e18a-45b8-8bf4-f7b4345d674e
 */

//var brushToggled = false;
const brushDefaultTop = 46;

const brushDefaultLeft = 49;
const brushDefaultRotation =  -33;

// Stores the initial position of the cursor
let coord = {x: Math.round(window.innerWidth / 2) , y: Math.round(window.innerHeight / 2)};

const canvas = document.querySelector('#ecp-paint-canvas');
var ctx = '';
if (canvas) {
  ctx = canvas.getContext('2d');  // Context for the canvas for 2 dimensional operations
  //console.log(ctx);
}


// This is the flag that we are going to use to
// trigger drawing

let paint = false;

//https://stackoverflow.com/questions/2142535/how-to-clear-the-canvas-for-redrawing
CanvasRenderingContext2D.prototype.clear = 
  CanvasRenderingContext2D.prototype.clear || function (preserveTransform) {
    if (preserveTransform) {
      this.save();
      this.setTransform(1, 0, 0, 1, 0, 0);
    }

    this.clearRect(0, 0, this.canvas.width, this.canvas.height);

    if (preserveTransform) {
      this.restore();
    }           
};


// Updates the coordianates of the cursor when
// an event e is triggered to the coordinates where
// the said event is triggered.
function getPosition(event){
  

  if (event.touches ==  null) {
    // Mouse
    var bounds = canvas.getBoundingClientRect();
    coord.x = event.clientX;
    coord.y = event.clientY - bounds.top;
  }
  else {
    event.preventDefault();


    var offset = $(canvas).offset();
    var touch = event.touches[0];
    //console.log('touched');
    //console.log('bounds.top ' + bounds.top);
    console.log('offset.top ' + offset.top);

    coord.x = touch.pageX;
    coord.y = touch.pageY - offset.top;
  }

  console.log('coord.x = ' + coord.x + ' coord.y = ' + coord.y);
}


 // Resizes the canvas to the available size of the window.
 function resizePaint(){
  if (canvas == null) return false;
  
  ctx.canvas.width = window.innerWidth;
  ctx.canvas.height = window.innerHeight;

}


// The following functions toggle the flag to start
// and stop drawing
function startPainting(event){
  paint = true;
  event.preventDefault();

  getPosition(event);
  //console.log ('Start Painting');
  $('#ecp-paint-brush').addClass('toggled');
  $('.ecp-block-section-object-container.paint').mousemove();
}
function stopPainting(){
  paint = false;
  $('#ecp-paint-brush').removeClass('toggled');
  $('#ecp-paint-brush').css({left: brushDefaultLeft + "%", top: brushDefaultTop + "%", transform: "translate(-50%, -50%) rotate("+brushDefaultRotation+"deg)"});
  ctx.clear();
}



function sketch(event){
  if (!paint) return;
  event.preventDefault();
  //console.log('sketch');

  $('#ecp-paint-brush').css({left: coord.x, top: coord.y});

  var rotateIt = "rotate(-" + Math.atan2(coord.x, coord.y) + "rad)"; // inverting it to point the other direction
  $('#ecp-paint-brush').css({transform: 'translate(-50%, 0%) ' + rotateIt});



  ctx.beginPath();
    
  ctx.lineWidth = 5;
  
  // Sets the end of the lines drawn
  // to a round shape.
  ctx.lineCap = 'round';
    
  ctx.strokeStyle = 'hsl(74.1 48% 62%)';
    
  // The cursor to start drawing
  // moves to this coordinate
  ctx.moveTo(coord.x, coord.y);
  
  // The position of the cursor
  // gets updated as we move the
  // mouse around.
  getPosition(event);
  
  // A line is traced from start
  // coordinate to this coordinate
  ctx.lineTo(coord.x , coord.y);
    
  // Draws the line.
  ctx.stroke();
  //console.log('x = ' + coord.x + ' y = ' + coord.y);
}





if (canvas) {
  resizePaint();
  window.addEventListener('resize', resizePaint);
  $( "#ecp-paint-brush" ).on( "mousedown", startPainting).on("touchstart", startPainting);
  $( "#ecp-paint-brush, .ecp-block-section-object-container.paint" ).on( "mouseup", stopPainting).on("touchend", stopPainting);
  //$('.ecp-block-section-object-container.paint').mousemove(sketch);
  $('#ecp-paint-canvas, .ecp-block-section-object-image-container.ecp-paint').mousemove(sketch).on("touchmove", sketch);
}
document.addEventListener('touchmove', sketch, false);


  
    /*
     * Do home animation based on mouse 
     */
  
    var targetTransX = 0,  targetTransY = 0, currentTransX = 0, currentTransY = 0;
    const moveModifierX = 1.2; // Adjusts the maximum move distance. Lower numbers move less.
    const moveModifierY = 3;// Adjusts the maximum move distance. Lower numbers move less.
    const moveCModifier = .04 // Adjusts how far to move C in relation to E. Higher numbers move more. 1 = same as E
    const speedModifier = .2; // adjusts the distance to move during each interval. Higher values move faster
    const speedReturnModifier = .4; // further adjusts the speed after mouseCounterCheck is reached
    var mouseMoved = false; // flag for whether the mouse moved recently
    var mouseCounter = 0; // timer counter for how long ago the mouse moved
    const mouseCounterCheck = 480; // how many timer intervals (frames) before mouseMoved is turned to false
    const timerInterval = 16.66; // 16.666= 60fps 33.33 = 30
    const allowPCE = true; // allows letters to invert order to spell PCE instead of ECP
    const ecpe = document.querySelector('.ecp-e');
    const ecpc = document.querySelector('.ecp-c');
    const ecpp = document.querySelectorAll('.ecp-p');
    /*var mouseScrolled = false;
    var mouseScrollCounter = 0;
    const mouseScrollCheck = 20;*/

    function initMouseMove() {
      $('.ecp-block-section-opening').mousemove(
        // Updates target location
        function(e){
          
          var w = this.offsetWidth;
          var h = this.offsetHeight;
          var x = e.pageX;// - this.offsetLeft;
          var y = e.pageY;// - this.offsetTop;
          var modH = h;
          if (w < h) modH = w; // use width on mobile for a modifier. 

          targetTransX = ((x / w) - .5) * (-100) * (moveModifierX / 2000) * w;
          targetTransY = ((y / h) - .5) * (-100) * (moveModifierY / 1500) * modH;//h;


          if (!mouseMoved) toggleMouseMoved();

        }
      );
      $('.ecp-block-section-opening').mouseleave(function() {
          if (mouseMoved) toggleMouseMoved();
          //console.log('mouseout');
      
      });

      setInterval(ecpMoveTimer, timerInterval);
    }
    initMouseMove();


    function ecpMoveTimer() {


      // Moves ECP letters toward the target
      var diffX = targetTransX - currentTransX;
      var diffY = targetTransY - currentTransY;

      var speed = (mouseMoved && mouseCounter < mouseCounterCheck) ? speedModifier : speedModifier*speedReturnModifier;
      

      // Only move if difference is more than 1px. Round movement to three digits
      if ( Math.abs(diffX) > 1) currentTransX = Math.round((currentTransX + (diffX * speed)) * 1000) / 1000; 
      if ( Math.abs(diffY) > 1) currentTransY = Math.round((currentTransY + (diffY * speed)) * 1000) / 1000; 
      
      // cap values to avoid PCE
      if (currentTransX > 30 && !allowPCE) currentTransX = 30;

      if ( Math.abs(diffY) > 1 || Math.abs(diffX) > 1) {
          // Only move if difference is more than 1px. 
          ecpe.style.transform = 'translate('+currentTransX+'%, '+currentTransY+'%)'; // Move E
          ecpc.style.transform = 'translate('+(currentTransX*moveCModifier)+'%, '+(currentTransY*moveCModifier)+'%)'; // Move C

          //ecpp.style.transform = 'translate('+ (-currentTransX) +'%, '+ (-currentTransY) +'%)'; // Move P opposite of E

          ecpp.forEach(function(item, index, arr){
            item.style.transform = 'translate('+ (-currentTransX) +'%, '+ (-currentTransY) +'%)'; // Move P opposite of E
          });


      } 
    

      // Mouse counter code
      mouseCounter++;
      if (mouseCounter >= mouseCounterCheck && mouseMoved) {
       
        toggleMouseMoved();
      }

    } 
    function cycleECP() {
      const ecp_p = document.querySelectorAll(".ecp-p");
      
      var found = false, index = 0;
      while (found === false && index < ecp_p.length) {
        //console.log('index: ' + index);
        if (!ecp_p[index].classList.contains('ecp-logo-hidden')) {
          // Found visible
          

          ecp_p[index].classList.add('ecp-logo-hidden'); 
          
          if (index != (ecp_p.length - 1)) {
            //show the next
            ecp_p[index + 1].classList.remove('ecp-logo-hidden'); 
            
          } else {
            // at the end, so show the first
            ecp_p[0].classList.remove('ecp-logo-hidden'); 
          }
          found = true;
        }
        index++;
      }
      
      
    }
    setInterval(cycleECP, 1000);


    function toggleMouseMoved() {
      mouseMoved = !mouseMoved; // toggle
      //console.log('mouseCounter = ' + mouseCounter);
      if (mouseMoved)  {
        mouseCounter = 0; // Reset counter
      } else {
        targetTransX = targetTransY = 0;
      }
    }
    



   /* 
     * Toggle menu/header sticky state based on scroll 
     * and close all side sections
     */
   var lastScrollTop = 0;
  
   $(window).scroll(function(){
     if (mouseMoved) toggleMouseMoved();

    //setTimeout(function(){
      closeObjectSections();
    //}, 1000);
     
   
     var scroll = $(window).scrollTop();
     var element = document.getElementById("main-nav");
 
     if (scroll > lastScrollTop){
       // downscroll code
       if(scroll < $( window ).height()){
         element.classList.remove("toggled");
       } else {
         element.classList.add("toggled");
       }
     } else {
       // upscroll code
       if(scroll < $( window ).height() / 2){
         if (element.classList.contains("toggled")) {
           element.classList.remove("toggled");
          //element.classList.add("toggled-out"); // Temporarily removed to fix glitch.. causes menu to go away without an animation when scrolling up. 
         }
         
       } else {
        // element.classList.add("toggled");
       }
       if(scroll < 1) {
         element.classList.remove("toggled-out");
         element.classList.remove("toggled");
       }
     }
     lastScrollTop = scroll;
   });






    /*
     * Ensure logo appears when menu is clicked on home page
     */
    $('.home .navbar-toggler, .ecm-mode .navbar-toggler').click(function(){
      $('.navbar-branding-container').toggleClass('toggled');
    });
    
    /*
     * Ensure nav text is black when menu is open
     */
    $('.navbar-toggler').click(function(){
      $('.navbar-toggler').toggleClass('toggled');
      $('#navbarSecondary').toggleClass('toggled');
      
      $('.custom-logo-link').toggleClass('toggled');
    });

/*
 * close menu on scroll
 */
$(window).scroll(function(){
  if ($('.navbar-toggler').hasClass('toggled')) {
    $('.navbar-toggler').click();
  }
  

});


    /*
     * Scroll to anchor if any
     */
   /* if (location.hash) {
      let target = location.hash;
      window.scrollTop = document.querySelector(target).offsetTop;
    }*/


    
    /*
     * Toggle Collapse on menu item click
     */

    $('#main-menu > li > a').click(function(){

      $('#navbarNavDropdown').collapse('hide');

      const a_href = $(this).attr('href');
      const hash = a_href.split('#').pop();
      const el = document.getElementById(hash);
      var section_link = el.getElementsByClassName('wp-element-button');
      if (section_link) {
        section_link = section_link[0];
        $('.custom-logo-link').toggleClass('toggled');

        setTimeout(function(){
          section_link.click();
        }, 1000);

        
      }

      //console.log(document.getElementById(hash));




    });











/*
 * Animate Accordions
 * https://codepen.io/chriscoyier/pen/XWNqxyY
 * https://css-tricks.com/how-to-animate-the-details-element/
 */



class Accordion {
  constructor(el) {
    // Store the <details> element
    this.el = el;
    // Store the <summary> element
    this.summary = el.querySelector('summary');
    // Store the <div class="content"> element
    this.content = el.querySelector('.wp-block-group');
    this.minHeight = 190;

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = 'hidden';
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.open();
    // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;
    
    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
   

    // Calculate the height of the summary
    //const endHeight = `${this.summary.offsetHeight}px`;
    var endHeight = `${this.summary.offsetHeight}`;
    if (endHeight < this.minHeight) endHeight = this.minHeight;
    endHeight = endHeight + 'px';
    //console.log(endHeight);
    
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    
    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    //const startHeight = `${this.el.offsetHeight}px`;
    var startHeight = `${this.el.offsetHeight}`;
    if (startHeight < this.minHeight) startHeight = this.minHeight;
    startHeight = startHeight + 'px';
    //console.log(startHeight);
    // Calculate the open height of the element (summary height + content height)
   
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }
    
    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = '';
  }
}

document.querySelectorAll('details.wp-block-details.ecm-accordion').forEach((el) => {
  new Accordion(el);
});




  })( jQuery );